/* GENERATED FILE - do not edit. Run: node scripts/generate-phosphor-icons.mjs */
import type { JSX } from 'solid-js'
import { IconBase, type IconProps, type WeightRenderers } from './IconBase'

const renderers: WeightRenderers = {
  regular: (color: string): JSX.Element => (
    <g>
      <circle
        cx="128"
        cy="128"
        r="96"
        fill="none"
        stroke={color}
        stroke-miterlimit="10"
        stroke-width="16"
      />
      <line
        x1="128"
        y1="80"
        x2="128"
        y2="136"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
      <circle cx="128" cy="172" r="12" />
    </g>
  ),
  bold: (color: string): JSX.Element => (
    <g>
      <circle
        cx="128"
        cy="128"
        r="96"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      />
      <line
        x1="128"
        y1="80"
        x2="128"
        y2="132"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="24"
      />
      <circle cx="128" cy="172" r="16" />
    </g>
  ),
  fill: (_color: string): JSX.Element => (
    <g>
      <path d="M128,24.00012a104,104,0,1,0,104,104A104.11759,104.11759,0,0,0,128,24.00012Zm-8,56a8,8,0,1,1,16,0v56a8,8,0,1,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184.00012Z" />
    </g>
  ),
}

export const WarningCircle = (props: IconProps) => <IconBase {...props} renderers={renderers} />
